import type { CallOutcome, RealEstateCase } from "./types";
import type { OutcomeConfigMap } from "./uiTypes";

export type NextActionUiState =
  | "READY"
  | "CALL_RESULT"
  | "OUTCOME_SCHEDULING"
  | "COMPLETION_SCHEDULING"
  | "RESCHEDULING"
  | "OWNER_RESULT"
  | "WAITING_RESULT"
  | "WAITING_SCHEDULING";

export type NextActionKind = "call" | "meeting" | "viewing" | "task";

export const nextActionKind = (caseItem: RealEstateCase): NextActionKind => {
  if (caseItem.leadState === "Čakajúci" || caseItem.stage === "Čakajúci") return "call";
  if (caseItem.followUp?.workflowId === "listing" || caseItem.followUp?.workflowId === "reservation") return "task";
  const context = `${caseItem.followUp?.purpose ?? ""} ${caseItem.nextStep} ${caseItem.stage}`.toLocaleLowerCase("sk");
  if (context.includes("obhliad")) return "viewing";
  if (context.includes("stretn")) return "meeting";
  if (
    context.includes("vola") ||
    context.includes("follow-up") ||
    context.includes("follow up") ||
    context.includes("kontaktovať")
  ) return "call";
  return "task";
};

export const outcomeNextUiState = (
  outcome: CallOutcome,
  outcomeConfig: OutcomeConfigMap
): NextActionUiState => outcomeConfig[outcome].requiresFollowUp ? "OUTCOME_SCHEDULING" : "CALL_RESULT";
